module.exports = __webpack_public_path__ + "img/image_online04@2x.b7c403ef.png";